import React from "react";
import { Input } from "antd";

/** Значение формы: "" или "+7XXXXXXXXXX"; на экране — +7 XXX XXX XX XX. */
export const normalizePhone = (raw) => {
  let digits = String(raw || "").replace(/\D/g, "");
  if (digits.length === 11 && (digits[0] === "7" || digits[0] === "8")) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  return digits ? `+7${digits}` : "";
};

/** Разбор строки из поля с маской: префикс «+7 » — не часть номера, иначе при удалении цифр 7 попадала бы в номер. */
const parseMasked = (text) => {
  const str = String(text || "");
  const body = /^\s*\+\s*7?/.test(str) ? str.replace(/^\s*\+\s*7?/, "") : str;
  let digits = body.replace(/\D/g, "");
  if (body === str && digits.length === 11 && (digits[0] === "7" || digits[0] === "8")) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  return digits ? `+7${digits}` : "";
};

export const formatPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "").replace(/^[78]/, "").slice(0, 10);
  if (!digits) return "";
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)].filter(Boolean);
  return `+7 ${parts.join(" ")}`;
};

export const isPhoneComplete = (value) => !value || /^\+7\d{10}$/.test(value);

export const phoneRule = {
  validator: (_, value) =>
    isPhoneComplete(value)
      ? Promise.resolve()
      : Promise.reject(new Error("Введите номер полностью: +7 XXX XXX XX XX"))
};

export const isEmailValid = (value) =>
  !value || !String(value).trim() || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());

export const emailRule = {
  validator: (_, value) =>
    isEmailValid(value) ? Promise.resolve() : Promise.reject(new Error("Некорректный адрес электронной почты"))
};

const PhoneInput = ({ value, onChange, ...rest }) => (
  <Input
    {...rest}
    inputMode="tel"
    placeholder="+7 ___ ___ __ __"
    value={formatPhone(value)}
    onChange={(e) => onChange?.(parseMasked(e.target.value))}
  />
);

export default PhoneInput;
